import HeroSlider from '../components/sections/HeroSlider';
import { departments, stats } from '../data';
import ServiceIcon from "../components/ui/ServiceIcon";
import './Home.css';

export default function Home({ setPage }) {
  return (
    <>
      {/* ── Hero ── */}
      <HeroSlider setPage={setPage} />

      {/* ── Stats ── */}
      <section className="section">
        <div className="section-inner">
          <div className="home__stats-layout">
            <div className="home__stats-left">
              <p className="section-label">Trusted Care, Compassionate Excellence</p>
              <h3 className="section-title">Capital Care International Hospital</h3>
              <p className="section-text">
                State-of-the-art modern secondary and tertiary care private hospital with a substantial inpatient capacity, including fully equipped ICU and NICU facilities. Strategically positioned to bridge the gap between primary care clinics and large tertiary institutions, we provide comprehensive healthcare services that combine affordability, accessibility, and clinical excellence. Our facility is supported by advanced medical technology, experienced specialists, and a strong commitment to patient-centered care, ensuring safe, efficient, and high-quality treatment across multiple specialties.
              </p>
            </div>
            <div className="home__stats-right">
              {stats.map(s => (
                <div key={s.label} className="home__stat-card">
                  <span className="home__stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── Departments ── */}
      <section className="section section--gray">
        <div className="section-inner">
          <div className="home__dept-header">
            <div>
              <p className="section-label">Department List</p>
              <h3 className="section-title">Our Expertise</h3>
            </div>
            <p className="section-text">
              Experience excellence in healthcare with our state-of-the-art medical departments,
              staffed by expert physicians and equipped with cutting-edge technology
            </p>
          </div>
          <div className="home__dept-grid">
            {departments.map(d => (
              <div key={d.name} className="home__dept-card" tabIndex={0}>
                <div className="home__dept-front">
                  <span className="home__dept-icon" aria-hidden="true">
                    <ServiceIcon name={d.key} />
                  </span>
                  <span className="home__dept-name">{d.name}</span>
                </div>
                <div className="home__dept-detail">
                  <img src={d.image} alt={d.name} loading="lazy" />
                  <span className="home__dept-detail-title">{d.name}</span>
                  <span className="home__dept-detail-text">{d.detail}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Medical Tourism ── */}
      {/* Our Services */}
      <section className="section">
        <div className="section-inner">
          <div className="home__services-header">
            <div>
              <p className="section-label">Our Services</p>
              <h3 className="section-title">In-Patient &amp; Out-Patient Care</h3>
            </div>
            <p className="section-text">
              From 24/7 emergency and critical care to OPD consultations and diagnostics, explore
              our services designed around safety, quality, and comfort.
            </p>
          </div>

          <div className="home__services-grid">
            <button type="button" className="home__services-card card" onClick={() => setPage("services-inpatient")}>
              <div className="home__services-card-top home__services-card-top--inpatient" aria-hidden="true" />
              <div className="home__services-card-body">
                <h3>In-Patient Services</h3>
                <p>Surgical, ER, ICU, and NICU services with specialist support.</p>
                <span className="home__services-link">Learn more</span>
              </div>
            </button>

            <button type="button" className="home__services-card card" onClick={() => setPage("services-outpatient")}>
              <div className="home__services-card-top home__services-card-top--outpatient" aria-hidden="true" />
              <div className="home__services-card-body">
                <h3>Out-Patient Services</h3>
                <p>OPD consultations, follow-ups, wellness care, and diagnostics.</p>
                <span className="home__services-link">Learn more</span>
              </div>
            </button>
          </div>

          <div className="home__services-actions">
            <button type="button" className="btn-outline" onClick={() => setPage("services")}>
              View All Services
            </button>
          </div>
        </div>
      </section>

      {/* Medical Tourism */}
      <section className="section">
        <div className="section-inner">
          <div className="home__tourism-layout">
            <div className="home__tourism-imgs">
              <div className="home__tourism-img home__tourism-img--tall">🏥</div>
              <div className="home__tourism-img">👨‍⚕️</div>
              <div className="home__tourism-img">🦷</div>
              <div className="home__tourism-img home__tourism-img--circle">👥</div>
            </div>
            <div>
              <h3 className="section-title">Our Commitment For A Better World</h3>
              <p className="section-text">
                Capital Care International Hospital features cutting-edge medical infrastructure designed to deliver world-class healthcare. Our facility includes 55+ beds, 6 dedicated ICU beds, and 3 Modular OT & 1 Minor OT equipped with the latest surgical technology.
                We maintain a fully equipped 24/7 emergency department with advanced life support systems, a modern dialysis unit, and comprehensive diagnostic imaging services including digital X-ray and ultrasound capabilities.
              </p>
              <div className="home__tourism-btns">
                <button className="btn-outline" onClick={() => setPage('contact')}>Get A Second Opinion</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Health Packages ── */}
      {/* Health Packages section removed */}

    </>
  );
}
